export const enWorldTourPlayerNames: { [key: string]: string } = {
  'player.great-britain/sunday-league/thursday-football/alan-allen':
    'Alan Allen',
  'player.great-britain/sunday-league/thursday-football/bob-roberts':
    'Bob Roberts',
  'player.great-britain/sunday-league/thursday-football/tom-thompson':
    'Tom Thompson',
  'player.great-britain/sunday-league/thursday-football/mickey-michaels':
    'Mickey Michaels',
  'player.great-britain/sunday-league/thursday-football/jack-johnson':
    'Jack Johnson',
  'player.great-britain/sunday-league/thursday-football/jon-jackson':
    'Jon Jackson',
  'player.great-britain/sunday-league/thursday-football/michael-michaels':
    'Michael Michaels',
  'player.great-britain/sunday-league/thursday-football/brett-the-hitman':
    'Brett The Hitman',
  'player.great-britain/sunday-league/thursday-football/daniel-daniels':
    'Daniel Daniels',
  'player.great-britain/sunday-league/thursday-football/paul-ralls':
    'Paul Ralls',
  'player.great-britain/sunday-league/thursday-football/adam-adams':
    'Adam Adams',
  'player.great-britain/sunday-league/team-chimera/humbaba': 'Humbaba',
  'player.great-britain/sunday-league/team-chimera/dan-darling': 'Dan Darling',
  'player.great-britain/sunday-league/team-chimera/chopper-curtis':
    'Chopper Curtis',
  'player.great-britain/sunday-league/team-chimera/ash': 'Ash',
  'player.great-britain/sunday-league/team-chimera/skrog-skullcrusher':
    'Skrog Skullcrusher',
  'player.great-britain/sunday-league/team-chimera/molla': 'Molla',
  'player.great-britain/sunday-league/team-chimera/mike-ruggers':
    'Mike Ruggers',
  'player.great-britain/sunday-league/team-chimera/robbie-rotweiler':
    'Robbie Rotweiler',
  'player.great-britain/sunday-league/team-chimera/iron-man-andy':
    'Iron Man Andy',
  'player.great-britain/sunday-league/team-chimera/jack-russell':
    'Jack Russell',
  'player.great-britain/sunday-league/team-chimera/alex-the-great':
    'Alex the Great',
  'player.great-britain/sunday-league/golden-oldies/copper-chris':
    'Copper Chris',
  'player.great-britain/sunday-league/golden-oldies/nifty-nickie':
    'Nifty Nickie',
  'player.great-britain/sunday-league/golden-oldies/matt-the-injured':
    'Matt the Injured',
  'player.great-britain/sunday-league/golden-oldies/rob-reliable':
    'Rob Reliable',
  'player.great-britain/sunday-league/golden-oldies/big-john': 'Big John',
  'player.great-britain/sunday-league/golden-oldies/ian-incredible':
    'Ian Incredible',
  'player.great-britain/sunday-league/golden-oldies/pirate-john': 'Pirate John',
  'player.great-britain/sunday-league/golden-oldies/mike-the-ref':
    'Mike the Ref',
  'player.great-britain/sunday-league/golden-oldies/terrific-taylor':
    'Terrific Taylor',
  'player.great-britain/sunday-league/golden-oldies/amazing-alan':
    'Amazing Alan',
  'player.great-britain/sunday-league/golden-oldies/rockstar-mark':
    'Rockstar Mark',
  'player.great-britain/sunday-league/tangerine-dream/phil-phenom':
    'Phil Phenom',
  'player.great-britain/sunday-league/tangerine-dream/chris-the-tactician':
    'Chris The Tactician',
  'player.great-britain/sunday-league/tangerine-dream/peter-bale': 'Peter Bale',
  'player.great-britain/sunday-league/tangerine-dream/ben-the-diver':
    'Ben The Diver',
  'player.great-britain/sunday-league/tangerine-dream/big-al': 'Big Al',
  'player.great-britain/sunday-league/tangerine-dream/awesome-andy':
    'Awesome Andy',
  'player.great-britain/sunday-league/tangerine-dream/beautiful-dan':
    'Beautiful Dan',
  'player.great-britain/sunday-league/tangerine-dream/daring-dave':
    'Daring Dave',
  'player.great-britain/sunday-league/tangerine-dream/paul-pace-abuse':
    'Paul Pace Abuse',
  'player.great-britain/sunday-league/tangerine-dream/craig-the-muffin':
    'Craig the Muffin',
  'player.great-britain/sunday-league/tangerine-dream/rocket-shot-ash':
    'Rocket Shot Ash',
  'player.great-britain/welsh-league/gelerts-guardians/bailey': 'Bailey',
  'player.great-britain/welsh-league/gelerts-guardians/mali': 'Mali',
  'player.great-britain/welsh-league/gelerts-guardians/max': 'Max',
  'player.great-britain/welsh-league/gelerts-guardians/bella': 'Bella',
  'player.great-britain/welsh-league/gelerts-guardians/twm': 'Twm',
  'player.great-britain/welsh-league/gelerts-guardians/ottie': 'Ottie',
  'player.great-britain/welsh-league/gelerts-guardians/tess': 'Tess',
  'player.great-britain/welsh-league/gelerts-guardians/molly': 'Molly',
  'player.great-britain/welsh-league/gelerts-guardians/biff': 'Biff',
  'player.great-britain/welsh-league/gelerts-guardians/rose': 'Rose',
  'player.great-britain/welsh-league/gelerts-guardians/charlie': 'Charlie',
  'player.great-britain/welsh-league/gelerts-guardians/patch': 'Patch',
  'player.great-britain/welsh-league/gelerts-guardians/gelert-jr.':
    'Gelert Jr.',
  'player.great-britain/welsh-league/gelerts-guardians/daisy': 'Daisy',
  'player.great-britain/welsh-league/gelerts-guardians/buddy': 'Buddy',
  'player.great-britain/welsh-league/gelerts-guardians/pip': 'Pip',
  'player.great-britain/welsh-league/gelerts-guardians/fang': 'Fang',
  'player.great-britain/welsh-league/gelerts-guardians/rocky': 'Rocky',
  'player.great-britain/welsh-league/gelerts-guardians/shadow': 'Shadow',
  'player.great-britain/welsh-league/gelerts-guardians/goldie': 'Goldie',
  'player.great-britain/welsh-league/llani-town-hobbits/bronwen-mossfoot':
    'Bronwen Mossfoot',
  'player.great-britain/welsh-league/llani-town-hobbits/taliesin-greenhill':
    'Taliesin Greenhill',
  'player.great-britain/welsh-league/llani-town-hobbits/efa-sandheaver':
    'Efa Sandheaver',
  'player.great-britain/welsh-league/llani-town-hobbits/idris-underhill':
    'Idris Underhill',
  'player.great-britain/welsh-league/llani-town-hobbits/hugh-edwards':
    'Hugh Edwards',
  'player.great-britain/welsh-league/llani-town-hobbits/llew-goodbarrel':
    'Llew Goodbarrel',
  'player.great-britain/welsh-league/llani-town-hobbits/eric-gervais':
    'Eric Gervais',
  'player.great-britain/welsh-league/llani-town-hobbits/owen-brandybuck':
    'Owen Brandybuck',
  'player.great-britain/welsh-league/llani-town-hobbits/marian-gervais':
    'Marian Gervais',
  'player.great-britain/welsh-league/llani-town-hobbits/dylan-longfoot':
    'Dylan Longfoot',
  'player.great-britain/welsh-league/llani-town-hobbits/seren-bagshot':
    'Seren Bagshot',
  'player.great-britain/welsh-league/llani-town-hobbits/gethin-proudfoot':
    'Gethin Proudfoot',
  'player.great-britain/welsh-league/llani-town-hobbits/myfanwy-chubb':
    'Myfanwy Chubb',
  'player.great-britain/welsh-league/llani-town-hobbits/rhys-hornblower':
    'Rhys Hornblower',
  'player.great-britain/welsh-league/llani-town-hobbits/lowri-gamgee':
    'Lowri Gamgee',
  'player.great-britain/welsh-league/llani-town-hobbits/ieuan-hayward':
    'Ieuan Hayward',
  'player.great-britain/welsh-league/llani-town-hobbits/siân-fairbairn':
    'Siân Fairbairn',
  'player.great-britain/welsh-league/llani-town-hobbits/carwyn-boffin':
    'Carwyn Boffin',
  'player.great-britain/welsh-league/llani-town-hobbits/aneira-took':
    'Aneira Took',
  'player.great-britain/welsh-league/llani-town-hobbits/dai-roper': 'Dai Roper',
  'player.great-britain/welsh-league/rhayader-red-kites/megan-lloyd':
    'Megan Lloyd',
  'player.great-britain/welsh-league/rhayader-red-kites/eleri-thomas':
    'Eleri Thomas',
  'player.great-britain/welsh-league/rhayader-red-kites/bethan-williams':
    'Bethan Williams',
  'player.great-britain/welsh-league/rhayader-red-kites/clara-macintyre':
    'Clara MacIntyre',
  'player.great-britain/welsh-league/rhayader-red-kites/carys-evans':
    'Carys Evans',
  'player.great-britain/welsh-league/rhayader-red-kites/rhian-jones':
    'Rhian Jones',
  'player.great-britain/welsh-league/rhayader-red-kites/gwenllian-morgan':
    'Gwenllian Morgan',
  'player.great-britain/welsh-league/rhayader-red-kites/nia-hughes':
    'Nia Hughes',
  'player.great-britain/welsh-league/rhayader-red-kites/saoirse-obrien':
    "Saoirse O'Brien",
  'player.great-britain/welsh-league/rhayader-red-kites/seren-roberts':
    'Seren Roberts',
  'player.great-britain/welsh-league/rhayader-red-kites/isla-thompson':
    'Isla Thompson',
  'player.great-britain/welsh-league/rhayader-red-kites/huw-davies':
    'Huw Davies',
  'player.great-britain/welsh-league/rhayader-red-kites/ffion-price':
    'Ffion Price',
  'player.great-britain/welsh-league/rhayader-red-kites/gareth-pugh':
    'Gareth Pugh',
  'player.great-britain/welsh-league/rhayader-red-kites/owen-tudor':
    'Owen Tudor',
  'player.great-britain/welsh-league/rhayader-red-kites/liam-oconnor':
    "Liam O'Connor",
  'player.great-britain/welsh-league/rhayader-red-kites/catrin-morris':
    'Catrin Morris',
  'player.great-britain/welsh-league/rhayader-red-kites/angharad-rees':
    'Angharad Rees',
  'player.great-britain/welsh-league/rhayader-red-kites/callum-macdonald':
    'Callum MacDonald',
  'player.great-britain/welsh-league/rhayader-red-kites/tom-jenkins':
    'Tom Jenkins',
  'player.great-britain/welsh-league/pembrokeshire-mermaids/mara': 'Mara',
  'player.great-britain/welsh-league/pembrokeshire-mermaids/morwenna':
    'Morwenna',
  'player.great-britain/welsh-league/pembrokeshire-mermaids/islay': 'Islay',
  'player.great-britain/welsh-league/pembrokeshire-mermaids/moira': 'Moira',
  'player.great-britain/welsh-league/pembrokeshire-mermaids/eirlys': 'Eirlys',
  'player.great-britain/welsh-league/pembrokeshire-mermaids/elspeth': 'Elspeth',
  'player.great-britain/welsh-league/pembrokeshire-mermaids/siobhan': 'Siobhan',
  'player.great-britain/welsh-league/pembrokeshire-mermaids/niamh': 'Niamh',
  'player.great-britain/welsh-league/pembrokeshire-mermaids/aine': 'Aine',
  'player.great-britain/welsh-league/pembrokeshire-mermaids/rhiannon':
    'Rhiannon',
  'player.great-britain/welsh-league/pembrokeshire-mermaids/peregrine':
    'Peregrine',
  'player.great-britain/welsh-league/pembrokeshire-mermaids/finnian': 'Finnian',
  'player.great-britain/welsh-league/pembrokeshire-mermaids/coralia': 'Coralia',
  'player.great-britain/welsh-league/pembrokeshire-mermaids/ronan': 'Ronan',
  'player.great-britain/welsh-league/pembrokeshire-mermaids/aerwyna': 'Aerwyna',
  'player.great-britain/welsh-league/pembrokeshire-mermaids/dylan': 'Dylan',
  'player.great-britain/welsh-league/pembrokeshire-mermaids/nerida': 'Nerida',
  'player.great-britain/welsh-league/pembrokeshire-mermaids/galia': 'Galia',
  'player.great-britain/welsh-league/pembrokeshire-mermaids/kaelen': 'Kaelen',
  'player.great-britain/welsh-league/pembrokeshire-mermaids/marius': 'Marius',
  'player.great-britain/welsh-league/ladies-of-the-lakes/aoife-omalley':
    "Aoife O'Malley",
  'player.great-britain/welsh-league/ladies-of-the-lakes/fiona-gallagher':
    'Fiona Gallagher',
  'player.great-britain/welsh-league/ladies-of-the-lakes/morag-campbell':
    'Morag Campbell',
  'player.great-britain/welsh-league/ladies-of-the-lakes/bronwen-lloyd':
    'Bronwen Lloyd',
  'player.great-britain/welsh-league/ladies-of-the-lakes/seren-griffith':
    'Seren Griffith',
  'player.great-britain/welsh-league/ladies-of-the-lakes/jane-smith':
    'Jane Smith',
  'player.great-britain/welsh-league/ladies-of-the-lakes/gwyneth-ellis':
    'Gwyneth Ellis',
  'player.great-britain/welsh-league/ladies-of-the-lakes/cerys-morgan':
    'Cerys Morgan',
  'player.great-britain/welsh-league/ladies-of-the-lakes/alys-hughes':
    'Alys Hughes',
  'player.great-britain/welsh-league/ladies-of-the-lakes/nerys-evans':
    'Nerys Evans',
  'player.great-britain/welsh-league/ladies-of-the-lakes/carys-john':
    'Carys John',
  'player.great-britain/welsh-league/ladies-of-the-lakes/rhiannon-jones':
    'Rhiannon Jones',
  'player.great-britain/welsh-league/ladies-of-the-lakes/niamh-kelly':
    'Niamh Kelly',
  'player.great-britain/welsh-league/ladies-of-the-lakes/eilidh-murray':
    'Eilidh Murray',
  'player.great-britain/welsh-league/ladies-of-the-lakes/siobhan-byrne':
    'Siobhan Byrne',
  'player.great-britain/welsh-league/ladies-of-the-lakes/lowri-davies':
    'Lowri Davies',
  'player.great-britain/welsh-league/ladies-of-the-lakes/moira-quinn':
    'Moira Quinn',
  'player.great-britain/welsh-league/ladies-of-the-lakes/isla-robertson':
    'Isla Robertson',
  'player.great-britain/welsh-league/ladies-of-the-lakes/saoirse-walsh':
    'Saoirse Walsh',
  'player.great-britain/welsh-league/ladies-of-the-lakes/megan-roberts':
    'Megan Roberts',
  'player.great-britain/welsh-league/port-talbot-orcs/gwenth-brakgul':
    'Gwenth Brakgul',
  'player.great-britain/welsh-league/port-talbot-orcs/alex-korgar':
    'Alex Korgar',
  'player.great-britain/welsh-league/port-talbot-orcs/bethan-uzbad':
    'Bethan Uzbad',
  'player.great-britain/welsh-league/port-talbot-orcs/gareth-muzgash':
    'Gareth Muzgash',
  'player.great-britain/welsh-league/port-talbot-orcs/megan-thurgash':
    'Megan Thurgash',
  'player.great-britain/welsh-league/port-talbot-orcs/sean-skarfang':
    'Sean Skarfang',
  'player.great-britain/welsh-league/port-talbot-orcs/emily-groth':
    'Emily Groth',
  'player.great-britain/welsh-league/port-talbot-orcs/rhys-lokk': 'Rhys Lokk',
  'player.great-britain/welsh-league/port-talbot-orcs/hamish-gashnak':
    'Hamish Gashnak',
  'player.great-britain/welsh-league/port-talbot-orcs/owen-snagtooth':
    'Owen Snagtooth',
  'player.great-britain/welsh-league/port-talbot-orcs/nerys-dushnamub':
    'Nerys Dushnamub',
  'player.great-britain/welsh-league/port-talbot-orcs/urgana-skullcrush':
    'Urgana Skullcrush',
  'player.great-britain/welsh-league/port-talbot-orcs/mog-ironhide':
    'Mog Ironhide',
  'player.great-britain/welsh-league/port-talbot-orcs/borog-tusksnarl':
    'Borog Tusksnarl',
  'player.great-britain/welsh-league/port-talbot-orcs/groka-mudstomp':
    'Groka Mudstomp',
  'player.great-britain/welsh-league/port-talbot-orcs/zog-rockhand':
    'Zog Rockhand',
  'player.great-britain/welsh-league/port-talbot-orcs/durg-stonebrow':
    'Durg Stonebrow',
  'player.great-britain/welsh-league/port-talbot-orcs/snaga-quickfoot':
    'Snaga Quickfoot',
  'player.great-britain/welsh-league/port-talbot-orcs/grishnákh-swiftaxe':
    'Grishnákh Swiftaxe',
  'player.great-britain/welsh-league/port-talbot-orcs/ufthak-gutripper':
    'Ufthak Gutripper',
  'player.great-britain/welsh-league/newport-chartists/leslie-moran':
    'Leslie Moran',
  'player.great-britain/welsh-league/newport-chartists/sian-powell':
    'Sian Powell',
  'player.great-britain/welsh-league/newport-chartists/andrew-oliver':
    'Andrew Oliver',
  'player.great-britain/welsh-league/newport-chartists/fiona-jones':
    'Fiona Jones',
  'player.great-britain/welsh-league/newport-chartists/michael-davies':
    'Michael Davies',
  'player.great-britain/welsh-league/newport-chartists/kristine-hughes':
    'Kristine Hughes',
  'player.great-britain/welsh-league/newport-chartists/dai-barwell':
    'Dai Barwell',
  'player.great-britain/welsh-league/newport-chartists/rachel-lewis':
    'Rachel Lewis',
  'player.great-britain/welsh-league/newport-chartists/danielle-evans':
    'Danielle Evans',
  'player.great-britain/welsh-league/newport-chartists/nigel-roberts':
    'Nigel Roberts',
  'player.great-britain/welsh-league/newport-chartists/olivia-morgan':
    'Olivia Morgan',
  'player.great-britain/welsh-league/newport-chartists/joan-aldridge':
    'Joan Aldridge',
  'player.great-britain/welsh-league/newport-chartists/tina-tynan':
    'Tina Tynan',
  'player.great-britain/welsh-league/newport-chartists/jac-frost': 'Jac Frost',
  'player.great-britain/welsh-league/newport-chartists/josie-labadie':
    'Josie Labadie',
  'player.great-britain/welsh-league/newport-chartists/patricia-amond':
    'Patricia Amond',
  'player.great-britain/welsh-league/newport-chartists/marcie-byrne':
    'Marcie Byrne',
  'player.great-britain/welsh-league/newport-chartists/michelle-demetriou':
    'Michelle Demetriou',
  'player.great-britain/welsh-league/newport-chartists/joanna-day':
    'Joanna Day',
  'player.great-britain/welsh-league/newport-chartists/mattie-dolan':
    'Mattie Dolan',
  'player.great-britain/welsh-league/wrexham-red-stars/alexis-steele':
    'Alexis Steele',
  'player.great-britain/welsh-league/wrexham-red-stars/ryan-pool': 'Ryan Pool',
  'player.great-britain/welsh-league/wrexham-red-stars/wild-card-willy':
    'Wild Card Willy',
  'player.great-britain/welsh-league/wrexham-red-stars/eva-blazek':
    'Eva Blazek',
  'player.great-britain/welsh-league/wrexham-red-stars/rico-montoya':
    'Rico Montoya',
  'player.great-britain/welsh-league/wrexham-red-stars/jade-liu': 'Jade Liu',
  'player.great-britain/welsh-league/wrexham-red-stars/rob-maverick':
    'Rob Maverick',
  'player.great-britain/welsh-league/wrexham-red-stars/scarlett-jones':
    'Scarlett Jones',
  'player.great-britain/welsh-league/wrexham-red-stars/red-paulson':
    'Red Paulson',
  'player.great-britain/welsh-league/wrexham-red-stars/natalie-nakamura':
    'Natalie Nakamura',
  'player.great-britain/welsh-league/wrexham-red-stars/paul-mighty':
    'Paul Mighty',
  'player.great-britain/welsh-league/wrexham-red-stars/sigourney-foster':
    'Sigourney Foster',
  'player.great-britain/welsh-league/wrexham-red-stars/samuel-l.-parkinson':
    'Samuel L. Parkinson',
  'player.great-britain/welsh-league/wrexham-red-stars/ellie-sattler-lee':
    'Ellie Sattler-Lee',
  'player.great-britain/welsh-league/wrexham-red-stars/gwendoline-palmer':
    'Gwendoline Palmer',
  'player.great-britain/welsh-league/wrexham-red-stars/saoirse-davies':
    'Saoirse Davies',
  'player.great-britain/welsh-league/wrexham-red-stars/sarah-hayden-connor':
    'Sarah Hayden-Connor',
  'player.great-britain/welsh-league/wrexham-red-stars/ben-lawrence':
    'Ben Lawrence',
  'player.great-britain/welsh-league/wrexham-red-stars/meryl-young':
    'Meryl Young',
  'player.great-britain/welsh-league/wrexham-red-stars/james-jolie':
    'James Jolie',
  'player.great-britain/welsh-league/blue-dragons/tom-heather': 'Tom Heather',
  'player.great-britain/welsh-league/blue-dragons/patricia-kavanagh':
    'Patricia Kavanagh',
  'player.great-britain/welsh-league/blue-dragons/danielle-collins':
    'Danielle Collins',
  'player.great-britain/welsh-league/blue-dragons/steven-manson':
    'Steven Manson',
  'player.great-britain/welsh-league/blue-dragons/andrew-taylor':
    'Andrew Taylor',
  'player.great-britain/welsh-league/blue-dragons/patricia-wittingham':
    'Patricia Wittingham',
  'player.great-britain/welsh-league/blue-dragons/alan-rambo': 'Alan Rambo',
  'player.great-britain/welsh-league/blue-dragons/michelle-hudson':
    'Michelle Hudson',
  'player.great-britain/welsh-league/blue-dragons/robert-blake': 'Robert Blake',
  'player.great-britain/welsh-league/blue-dragons/freda-chopra': 'Freda Chopra',
  'player.great-britain/welsh-league/blue-dragons/capital-dragon':
    'Capital Dragon',
  'player.great-britain/welsh-league/blue-dragons/davina-marshall':
    'Davina Marshall',
  'player.great-britain/welsh-league/blue-dragons/marge-hudson': 'Marge Hudson',
  'player.great-britain/welsh-league/blue-dragons/kevina-mcnaughton':
    'Kevina McNaughton',
  'player.great-britain/welsh-league/blue-dragons/stephanie-mcphail':
    'Stephanie McPhail',
  'player.great-britain/welsh-league/blue-dragons/joanne-ledley':
    'Joanne Ledley',
  'player.great-britain/welsh-league/blue-dragons/donna-cowie': 'Donna Cowie',
  'player.great-britain/welsh-league/blue-dragons/jaynie-bothroyd':
    'Jaynie Bothroyd',
  'player.great-britain/welsh-league/blue-dragons/petra-odemwingie':
    'Petra Odemwingie',
  'player.great-britain/welsh-league/blue-dragons/fabia-da-silva':
    'Fabia Da Silva',
  'player.great-britain/welsh-league/swansea-black-swans/isabella-vorm':
    'Isabella Vorm',
  'player.great-britain/welsh-league/swansea-black-swans/ann-rangel':
    'Ann Rangel',
  'player.great-britain/welsh-league/swansea-black-swans/ashley-jones':
    'Ashley Jones',
  'player.great-britain/welsh-league/swansea-black-swans/alun-taylor':
    'Alun Taylor',
  'player.great-britain/welsh-league/swansea-black-swans/bethan-davies':
    'Bethan Davies',
  'player.great-britain/welsh-league/swansea-black-swans/josie-allen':
    'Josie Allen',
  'player.great-britain/welsh-league/swansea-black-swans/noah-davenport':
    'Noah Davenport',
  'player.great-britain/welsh-league/swansea-black-swans/lyla-britton':
    'Lyla Britton',
  'player.great-britain/welsh-league/swansea-black-swans/bonnie-wilfred':
    'Bonnie Wilfred',
  'player.great-britain/welsh-league/swansea-black-swans/lee-trickster':
    'Lee Trickster',
  'player.great-britain/welsh-league/swansea-black-swans/jenna-shelvey':
    'Jenna Shelvey',
  'player.great-britain/welsh-league/swansea-black-swans/lucia-fabianska':
    'Lucia Fabianska',
  'player.great-britain/welsh-league/swansea-black-swans/gary-monkman':
    'Gary Monkman',
  'player.great-britain/welsh-league/swansea-black-swans/wendy-routledge':
    'Wendy Routledge',
  'player.great-britain/welsh-league/swansea-black-swans/danielle-graham':
    'Danielle Graham',
  'player.great-britain/welsh-league/swansea-black-swans/kim-sung-yoon':
    'Kim Sung-yoon',
  'player.great-britain/welsh-league/swansea-black-swans/chica-flores':
    'Chica Flores',
  'player.great-britain/welsh-league/swansea-black-swans/paola-hernandez':
    'Paola Hernandez',
  'player.great-britain/welsh-league/swansea-black-swans/gylda-sigurdardottir':
    'Gylda Sigurdardottir',
  'player.great-britain/welsh-league/swansea-black-swans/kyla-naughton':
    'Kyla Naughton',
  'player.great-britain/welsh-league/knights-of-the-round-table/sir-kay':
    'Sir Kay',
  'player.great-britain/welsh-league/knights-of-the-round-table/sir-percival':
    'Sir Percival',
  'player.great-britain/welsh-league/knights-of-the-round-table/sir-gareth':
    'Sir Gareth',
  'player.great-britain/welsh-league/knights-of-the-round-table/sir-gawain':
    'Sir Gawain',
  'player.great-britain/welsh-league/knights-of-the-round-table/sir-tristan':
    'Sir Tristan',
  'player.great-britain/welsh-league/knights-of-the-round-table/sir-bedivere':
    'Sir Bedivere',
  'player.great-britain/welsh-league/knights-of-the-round-table/sir-galahad':
    'Sir Galahad',
  'player.great-britain/welsh-league/knights-of-the-round-table/king-arthur':
    'King Arthur',
  'player.great-britain/welsh-league/knights-of-the-round-table/sir-bors':
    'Sir Bors',
  'player.great-britain/welsh-league/knights-of-the-round-table/sir-gaheris':
    'Sir Gaheris',
  'player.great-britain/welsh-league/knights-of-the-round-table/sir-lancelot':
    'Sir Lancelot',
  'player.great-britain/welsh-league/knights-of-the-round-table/sir-ector':
    'Sir Ector',
  'player.great-britain/welsh-league/knights-of-the-round-table/sir-lucan':
    'Sir Lucan',
  'player.great-britain/welsh-league/knights-of-the-round-table/sir-dinadan':
    'Sir Dinadan',
  'player.great-britain/welsh-league/knights-of-the-round-table/sir-griflet':
    'Sir Griflet',
  'player.great-britain/welsh-league/knights-of-the-round-table/sir-uwaine':
    'Sir Uwaine',
  'player.great-britain/welsh-league/knights-of-the-round-table/sir-agravain':
    'Sir Agravain',
  'player.great-britain/welsh-league/knights-of-the-round-table/sir-pelleas':
    'Sir Pelleas',
  'player.great-britain/welsh-league/knights-of-the-round-table/sir-lamorak':
    'Sir Lamorak',
  'player.great-britain/welsh-league/knights-of-the-round-table/sir-constantine':
    'Sir Constantine',
  'player.great-britain/scottish-league/blue-men-of-minch/finn-maccool':
    'Finn MacCool',
  'player.great-britain/scottish-league/blue-men-of-minch/ewan-mctide':
    'Ewan McTide',
  'player.great-britain/scottish-league/blue-men-of-minch/duncan-stormrider':
    'Duncan Stormrider',
  'player.great-britain/scottish-league/blue-men-of-minch/lachlan-deepwave':
    'Lachlan Deepwave',
  'player.great-britain/scottish-league/blue-men-of-minch/callum-whirlpool':
    'Callum Whirlpool',
  'player.great-britain/scottish-league/blue-men-of-minch/rory-seastorm':
    'Rory Seastorm',
  'player.great-britain/scottish-league/blue-men-of-minch/angus-wavebreaker':
    'Angus Wavebreaker',
  'player.great-britain/scottish-league/blue-men-of-minch/dougal-mariner':
    'Dougal Mariner',
  'player.great-britain/scottish-league/blue-men-of-minch/fergus-tidesinger':
    'Fergus Tidesinger',
  'player.great-britain/scottish-league/blue-men-of-minch/hamish-oceanheart':
    'Hamish Oceanheart',
  'player.great-britain/scottish-league/blue-men-of-minch/iain-vortex':
    'Iain Vortex',
  'player.great-britain/scottish-league/blue-men-of-minch/alasdair-current':
    'Alasdair Current',
  'player.great-britain/scottish-league/blue-men-of-minch/niall-kelpie':
    'Niall Kelpie',
  'player.great-britain/scottish-league/blue-men-of-minch/morag-seabrook':
    'Morag Seabrook',
  'player.great-britain/scottish-league/blue-men-of-minch/kenneth-coral':
    'Kenneth Coral',
  'player.great-britain/scottish-league/blue-men-of-minch/elspeth-spray':
    'Elspeth Spray',
  'player.great-britain/scottish-league/blue-men-of-minch/gordon-inlet':
    'Gordon Inlet',
  'player.great-britain/scottish-league/blue-men-of-minch/jean-abyss':
    'Jean Abyss',
  'player.great-britain/scottish-league/blue-men-of-minch/robbie-shoal':
    'Robbie Shoal',
  'player.great-britain/scottish-league/silver-hoofs/ewan-mackinnon':
    'Ewan MacKinnon',
  'player.great-britain/scottish-league/silver-hoofs/fiona-odonell':
    "Fiona O'Donell",
  'player.great-britain/scottish-league/silver-hoofs/gareth-davies':
    'Gareth Davies',
  'player.great-britain/scottish-league/silver-hoofs/bronwyn-llewellyn':
    'Bronwyn Llewellyn',
  'player.great-britain/scottish-league/silver-hoofs/aiden-orourke':
    "Aiden O'Rourke",
  'player.great-britain/scottish-league/silver-hoofs/rhona-macleod':
    'Rhona MacLeod',
  'player.great-britain/scottish-league/silver-hoofs/owen-gwynn': 'Owen Gwynn',
  'player.great-britain/scottish-league/silver-hoofs/ciara-byrne':
    'Ciara Byrne',
  'player.great-britain/scottish-league/silver-hoofs/liam-fraser':
    'Liam Fraser',
  'player.great-britain/scottish-league/silver-hoofs/gwendolyn-morgan':
    'Gwendolyn Morgan',
  'player.great-britain/scottish-league/silver-hoofs/connor-maccormack':
    'Connor MacCormack',
  'player.great-britain/scottish-league/silver-hoofs/colt-campbell':
    'Colt Campbell',
  'player.great-britain/scottish-league/silver-hoofs/filly-flynn':
    'Filly Flynn',
  'player.great-britain/scottish-league/silver-hoofs/stable-stewart':
    'Stable Stewart',
  'player.great-britain/scottish-league/silver-hoofs/paddock-paddy':
    'Paddock Paddy',
  'player.great-britain/scottish-league/silver-hoofs/bridie-bridle':
    'Bridie Bridle',
  'player.great-britain/scottish-league/silver-hoofs/gallop-gavin':
    'Gallop Gavin',
  'player.great-britain/scottish-league/silver-hoofs/hayley-hoof':
    'Hayley Hoof',
  'player.great-britain/scottish-league/silver-hoofs/kelpie-kyle':
    'Kelpie Kyle',
  'player.great-britain/scottish-league/silver-hoofs/mare-morgan':
    'Mare Morgan',
  'player.great-britain/scottish-league/highland-raptors/callum-macleod':
    'Callum MacLeod',
  'player.great-britain/scottish-league/highland-raptors/erin-sinclair':
    'Erin Sinclair',
  'player.great-britain/scottish-league/highland-raptors/rhys-williams':
    'Rhys Williams',
  'player.great-britain/scottish-league/highland-raptors/ava-griffiths':
    'Ava Griffiths',
  'player.great-britain/scottish-league/highland-raptors/liam-odonnell':
    "Liam O'Donnell",
  'player.great-britain/scottish-league/highland-raptors/fiona-douglas':
    'Fiona Douglas',
  'player.great-britain/scottish-league/highland-raptors/connor-murphy':
    'Connor Murphy',
  'player.great-britain/scottish-league/highland-raptors/isla-campbell':
    'Isla Campbell',
  'player.great-britain/scottish-league/highland-raptors/evan-jones':
    'Evan Jones',
  'player.great-britain/scottish-league/highland-raptors/maeve-oneil':
    "Maeve O'Neil",
  'player.great-britain/scottish-league/highland-raptors/dylan-macgregor':
    'Dylan MacGregor',
  'player.great-britain/scottish-league/highland-raptors/alasdair-glen':
    'Alasdair Glen',
  'player.great-britain/scottish-league/highland-raptors/sorcha-peak':
    'Sorcha Peak',
  'player.great-britain/scottish-league/highland-raptors/hamish-crag':
    'Hamish Crag',
  'player.great-britain/scottish-league/highland-raptors/elspeth-talon':
    'Elspeth Talon',
  'player.great-britain/scottish-league/highland-raptors/kester-ridge':
    'Kester Ridge',
  'player.great-britain/scottish-league/highland-raptors/morag-sky':
    'Morag Sky',
  'player.great-britain/scottish-league/highland-raptors/niall-lochlan':
    'Niall Lochlan',
  'player.great-britain/scottish-league/highland-raptors/rowan-stone':
    'Rowan Stone',
  'player.great-britain/scottish-league/highland-raptors/blair-munro':
    'Blair Munro',
  'player.great-britain/scottish-league/thistle-knights/fiona-macgregor':
    'Fiona MacGregor',
  'player.great-britain/scottish-league/thistle-knights/ewan-robertson':
    'Ewan Robertson',
  'player.great-britain/scottish-league/thistle-knights/isla-hamilton':
    'Isla Hamilton',
  'player.great-britain/scottish-league/thistle-knights/callum-macleod':
    'Callum MacLeod',
  'player.great-britain/scottish-league/thistle-knights/kirsty-fraser':
    'Kirsty Fraser',
  'player.great-britain/scottish-league/thistle-knights/liam-stewart':
    'Liam Stewart',
  'player.great-britain/scottish-league/thistle-knights/rachel-douglas':
    'Rachel Douglas',
  'player.great-britain/scottish-league/thistle-knights/scott-mckenzie':
    'Scott McKenzie',
  'player.great-britain/scottish-league/thistle-knights/grace-anderson':
    'Grace Anderson',
  'player.great-britain/scottish-league/thistle-knights/aiden-macpherson':
    'Aiden MacPherson',
  'player.great-britain/scottish-league/thistle-knights/emma-gordon':
    'Emma Gordon',
  'player.great-britain/scottish-league/thistle-knights/blair-sinclair':
    'Blair Sinclair',
  'player.great-britain/scottish-league/thistle-knights/hamish-wallace':
    'Hamish Wallace',
  'player.great-britain/scottish-league/thistle-knights/niall-armour':
    'Niall Armour',
  'player.great-britain/scottish-league/thistle-knights/sorcha-shield':
    'Sorcha Shield',
  'player.great-britain/scottish-league/thistle-knights/morag-banner':
    'Morag Banner',
  'player.great-britain/scottish-league/thistle-knights/keir-lance':
    'Keir Lance',
  'player.great-britain/scottish-league/thistle-knights/alba-guard':
    'Alba Guard',
  'player.great-britain/scottish-league/thistle-knights/struan-battle':
    'Struan Battle',
  'player.great-britain/scottish-league/thistle-knights/mhairi-pike':
    'Mhairi Pike',
  'player.great-britain/scottish-league/dundee-dragons/drakon': 'Drakon',
  'player.great-britain/scottish-league/dundee-dragons/eldora-flamehart':
    'Eldora Flamehart',
  'player.great-britain/scottish-league/dundee-dragons/martin-stormshield':
    'Martin Stormshield',
  'player.great-britain/scottish-league/dundee-dragons/sylvia-flamehart':
    'Sylvia Flamehart',
  'player.great-britain/scottish-league/dundee-dragons/iris-flamehart':
    'Iris Flamehart',
  'player.great-britain/scottish-league/dundee-dragons/luna-flamehart':
    'Luna Flamehart',
  'player.great-britain/scottish-league/dundee-dragons/aurora-flamehart':
    'Aurora Flamehart',
  'player.great-britain/scottish-league/dundee-dragons/terra-flamehart':
    'Terra Flamehart',
  'player.great-britain/scottish-league/dundee-dragons/cassia-flamehart':
    'Cassia Flamehart',
  'player.great-britain/scottish-league/dundee-dragons/selena-flamehart':
    'Selena Flamehart',
  'player.great-britain/scottish-league/dundee-dragons/lyra-flamehart':
    'Lyra Flamehart',
  'player.great-britain/scottish-league/dundee-dragons/angus-drake':
    'Angus Drake',
  'player.great-britain/scottish-league/dundee-dragons/fiona-scalehide':
    'Fiona Scalehide',
  'player.great-britain/scottish-league/dundee-dragons/hamish-ember':
    'Hamish Ember',
  'player.great-britain/scottish-league/dundee-dragons/isla-inferno':
    'Isla Inferno',
  'player.great-britain/scottish-league/dundee-dragons/lachlan-pyre':
    'Lachlan Pyre',
  'player.great-britain/scottish-league/dundee-dragons/morna-cinder':
    'Morna Cinder',
  'player.great-britain/scottish-league/dundee-dragons/rory-firebrand':
    'Rory Firebrand',
  'player.great-britain/scottish-league/dundee-dragons/sorcha-wyrm':
    'Sorcha Wyrm',
  'player.great-britain/scottish-league/dundee-dragons/tavish-smoulder':
    'Tavish Smoulder',
  'player.great-britain/scottish-league/redcap-rovers/duncan-macgregor':
    'Duncan MacGregor',
  'player.great-britain/scottish-league/redcap-rovers/eilidh-wallace':
    'Eilidh Wallace',
  'player.great-britain/scottish-league/redcap-rovers/callum-stewart':
    'Callum Stewart',
  'player.great-britain/scottish-league/redcap-rovers/iona-campbell':
    'Iona Campbell',
  'player.great-britain/scottish-league/redcap-rovers/liam-ross': 'Liam Ross',
  'player.great-britain/scottish-league/redcap-rovers/fiona-macdonald':
    'Fiona MacDonald',
  'player.great-britain/scottish-league/redcap-rovers/angus-fraser':
    'Angus Fraser',
  'player.great-britain/scottish-league/redcap-rovers/kirsty-thomson':
    'Kirsty Thomson',
  'player.great-britain/scottish-league/redcap-rovers/gavin-reid': 'Gavin Reid',
  'player.great-britain/scottish-league/redcap-rovers/skye-mclean':
    'Skye McLean',
  'player.great-britain/scottish-league/redcap-rovers/connor-murray':
    'Connor Murray',
  'player.great-britain/scottish-league/redcap-rovers/tam-lin': 'Tam Lin',
  'player.great-britain/scottish-league/redcap-rovers/rab-nesbittan':
    'Rab Nesbittan',
  'player.great-britain/scottish-league/redcap-rovers/paddy-rogue':
    'Paddy Rogue',
  'player.great-britain/scottish-league/redcap-rovers/brodie-moss':
    'Brodie Moss',
  'player.great-britain/scottish-league/redcap-rovers/janet-fell': 'Janet Fell',
  'player.great-britain/scottish-league/redcap-rovers/logan-stone':
    'Logan Stone',
  'player.great-britain/scottish-league/redcap-rovers/morven-march':
    'Morven March',
  'player.great-britain/scottish-league/redcap-rovers/finlay-bramble':
    'Finlay Bramble',
  'player.great-britain/scottish-league/redcap-rovers/grant-thistle':
    'Grant Thistle',
  'player.great-britain/scottish-league/wisp-wanderers/aiden-griffiths':
    'Aiden Griffiths',
  'player.great-britain/scottish-league/wisp-wanderers/eilidh-macintyre':
    'Eilidh MacIntyre',
  'player.great-britain/scottish-league/wisp-wanderers/rowan-oconnell':
    "Rowan O'Connell",
  'player.great-britain/scottish-league/wisp-wanderers/gwen-powell':
    'Gwen Powell',
  'player.great-britain/scottish-league/wisp-wanderers/liam-doyle':
    'Liam Doyle',
  'player.great-britain/scottish-league/wisp-wanderers/morgan-davies':
    'Morgan Davies',
  'player.great-britain/scottish-league/wisp-wanderers/siobhan-kennedy':
    'Siobhan Kennedy',
  'player.great-britain/scottish-league/wisp-wanderers/finlay-ross':
    'Finlay Ross',
  'player.great-britain/scottish-league/wisp-wanderers/dylan-hughes':
    'Dylan Hughes',
  'player.great-britain/scottish-league/wisp-wanderers/niamh-murphy':
    'Niamh Murphy',
  'player.great-britain/scottish-league/wisp-wanderers/caitlin-oneal':
    "Caitlin O'Neal",
  'player.great-britain/scottish-league/wisp-wanderers/glimmer-greer':
    'Glimmer Greer',
  'player.great-britain/scottish-league/wisp-wanderers/shade-sullivan':
    'Shade Sullivan',
  'player.great-britain/scottish-league/wisp-wanderers/flicker-flynn':
    'Flicker Flynn',
  'player.great-britain/scottish-league/wisp-wanderers/marsh-malcolm':
    'Marsh Malcolm',
  'player.great-britain/scottish-league/wisp-wanderers/willow-walsh':
    'Willow Walsh',
  'player.great-britain/scottish-league/wisp-wanderers/glowen-rhys':
    'Glowen Rhys',
  'player.great-britain/scottish-league/wisp-wanderers/mist-megan':
    'Mist Megan',
  'player.great-britain/scottish-league/wisp-wanderers/sprite-sorley':
    'Sprite Sorley',
  'player.great-britain/scottish-league/wisp-wanderers/fen-fergus':
    'Fen Fergus',
  'player.great-britain/scottish-league/loch-ness-monsters/nessie-mcguard':
    'Nessie McGuard',
  'player.great-britain/scottish-league/loch-ness-monsters/finn-oswim':
    "Finn O'Swim",
  'player.great-britain/scottish-league/loch-ness-monsters/scaleigh-mctackle':
    'Scaleigh McTackle',
  'player.great-britain/scottish-league/loch-ness-monsters/gillian-waters':
    'Gillian Waters',
  'player.great-britain/scottish-league/loch-ness-monsters/marina-splash':
    'Marina Splash',
  'player.great-britain/scottish-league/loch-ness-monsters/wade-banks':
    'Wade Banks',
  'player.great-britain/scottish-league/loch-ness-monsters/lochlan-wavecrest':
    'Lochlan Wavecrest',
  'player.great-britain/scottish-league/loch-ness-monsters/brooke-eddy':
    'Brooke Eddy',
  'player.great-britain/scottish-league/loch-ness-monsters/ness': 'Ness',
  'player.great-britain/scottish-league/loch-ness-monsters/laken-torrent':
    'Laken Torrent',
  'player.great-britain/scottish-league/loch-ness-monsters/ripple-mcsplash':
    'Ripple McSplash',
  'player.great-britain/scottish-league/loch-ness-monsters/plesio-petra':
    'Plesio Petra',
  'player.great-britain/scottish-league/loch-ness-monsters/tidal-rex':
    'Tidal Rex',
  'player.great-britain/scottish-league/loch-ness-monsters/aqua-angus':
    'Aqua Angus',
  'player.great-britain/scottish-league/loch-ness-monsters/current-callum':
    'Current Callum',
  'player.great-britain/scottish-league/loch-ness-monsters/deep-morag':
    'Deep Morag',
  'player.great-britain/scottish-league/loch-ness-monsters/fossil-fiona':
    'Fossil Fiona',
  'player.great-britain/scottish-league/loch-ness-monsters/gaelic-gulp':
    'Gaelic Gulp',
  'player.great-britain/scottish-league/loch-ness-monsters/kelp-kester':
    'Kelp Kester',
  'player.great-britain/scottish-league/loch-ness-monsters/lagoon-liam':
    'Lagoon Liam',
  'player.great-britain/scottish-league/aberdeen-angus/alexia-mcdougall':
    'Alexia McDougall',
  'player.great-britain/scottish-league/aberdeen-angus/roberta-mcleish':
    'Roberta McLeish',
  'player.great-britain/scottish-league/aberdeen-angus/marley-cooper':
    'Marley Cooper',
  'player.great-britain/scottish-league/aberdeen-angus/willa-miller':
    'Willa Miller',
  'player.great-britain/scottish-league/aberdeen-angus/daniela-simmers':
    'Daniela Simmers',
  'player.great-britain/scottish-league/aberdeen-angus/erin-strachan':
    'Erin Strachan',
  'player.great-britain/scottish-league/aberdeen-angus/euan-mcmaster':
    'Euan McMaster',
  'player.great-britain/scottish-league/aberdeen-angus/simone-paatelainen':
    'Simone Paatelainen',
  'player.great-britain/scottish-league/aberdeen-angus/frances-mcpherson':
    'Frances McPherson',
  'player.great-britain/scottish-league/aberdeen-angus/joanne-smith':
    'Joanne Smith',
  'player.great-britain/scottish-league/aberdeen-angus/charlotte-glass':
    'Charlotte Glass',
  'player.great-britain/scottish-league/aberdeen-angus/neil-simpsonsson':
    'Neil Simpsonsson',
  'player.great-britain/scottish-league/aberdeen-angus/peter-weirwood':
    'Peter Weirwood',
  'player.great-britain/scottish-league/aberdeen-angus/doug-roughed':
    'Doug Roughed',
  'player.great-britain/scottish-league/aberdeen-angus/stuart-kenney':
    'Stuart Kenney',
  'player.great-britain/scottish-league/aberdeen-angus/eric-blackwood':
    'Eric Blackwood',
  'player.great-britain/scottish-league/aberdeen-angus/drew-jarvie':
    'Drew Jarvie',
  'player.great-britain/scottish-league/aberdeen-angus/arilda-stavrum':
    'Arilda Stavrum',
  'player.great-britain/scottish-league/aberdeen-angus/russell-andersonian':
    'Russell Andersonian',
  'player.great-britain/scottish-league/aberdeen-angus/billy-starkers':
    'Billy Starkers',
  'player.great-britain/scottish-league/glasgow-guardians/aaron-gable':
    'Aaron Gable',
  'player.great-britain/scottish-league/glasgow-guardians/isaac-dalton':
    'Isaac Dalton',
  'player.great-britain/scottish-league/glasgow-guardians/rebecca-grant':
    'Rebecca Grant',
  'player.great-britain/scottish-league/glasgow-guardians/butcher': 'Butcher',
  'player.great-britain/scottish-league/glasgow-guardians/diana-walker':
    'Diana Walker',
  'player.great-britain/scottish-league/glasgow-guardians/benjamin-foster':
    'Benjamin Foster',
  'player.great-britain/scottish-league/glasgow-guardians/patricia-gascoigne':
    'Patricia Gascoigne',
  'player.great-britain/scottish-league/glasgow-guardians/maxwell-harper':
    'Maxwell Harper',
  'player.great-britain/scottish-league/glasgow-guardians/rachel-warner':
    'Rachel Warner',
  'player.great-britain/scottish-league/glasgow-guardians/alexandra-mccoist':
    'Alexandra McCoist',
  'player.great-britain/scottish-league/glasgow-guardians/brandon-laudrup':
    'Brandon Laudrup',
  'player.great-britain/scottish-league/glasgow-guardians/jock-greyson':
    'Jock Greyson',
  'player.great-britain/scottish-league/glasgow-guardians/sandy-jardineer':
    'Sandy Jardineer',
  'player.great-britain/scottish-league/glasgow-guardians/connor-goldstar':
    'Connor Goldstar',
  'player.great-britain/scottish-league/glasgow-guardians/jim-baxterman':
    'Jim Baxterman',
  'player.great-britain/scottish-league/glasgow-guardians/davie-cooperfield':
    'Davie Cooperfield',
  'player.great-britain/scottish-league/glasgow-guardians/stefan-kloset':
    'Stefan Kloset',
  'player.great-britain/scottish-league/glasgow-guardians/jorg-albertsson':
    'Jorg Albertsson',
  'player.great-britain/scottish-league/glasgow-guardians/nikki-jelavic':
    'Nikki Jelavic',
  'player.great-britain/scottish-league/glasgow-guardians/stevie-naismithian':
    'Stevie Naismithian',
  'player.great-britain/scottish-league/celtic-warriors/patricia-bonner':
    'Patricia Bonner',
  'player.great-britain/scottish-league/celtic-warriors/declan-mccarthy':
    'Declan McCarthy',
  'player.great-britain/scottish-league/celtic-warriors/brendan-macnally':
    'Brendan MacNally',
  'player.great-britain/scottish-league/celtic-warriors/virginia-van-dijk':
    'Virginia van Dijk',
  'player.great-britain/scottish-league/celtic-warriors/tristan-gallagher':
    'Tristan Gallagher',
  'player.great-britain/scottish-league/celtic-warriors/jenny-johnstone':
    'Jenny Johnstone',
  'player.great-britain/scottish-league/celtic-warriors/bradley-lennox':
    'Bradley Lennox',
  'player.great-britain/scottish-league/celtic-warriors/niall-lennon':
    'Niall Lennon',
  'player.great-britain/scottish-league/celtic-warriors/jesse-fraser':
    'Jesse Fraser',
  'player.great-britain/scottish-league/celtic-warriors/warrior-king':
    'Warrior King',
  'player.great-britain/scottish-league/celtic-warriors/erika-larsson':
    'Erika Larsson',
  'player.great-britain/scottish-league/celtic-warriors/saul-mcstaysafe':
    'Saul McStaySafe',
  'player.great-britain/scottish-league/celtic-warriors/scottie-gryffe':
    'Scottie Gryffe',
  'player.great-britain/scottish-league/celtic-warriors/shun-akamura':
    'Shun Akamura',
  'player.great-britain/scottish-league/celtic-warriors/kieran-tiernorth':
    'Kieran Tiernorth',
  'player.great-britain/scottish-league/celtic-warriors/tommy-rogue':
    'Tommy Rogue',
  'player.great-britain/scottish-league/celtic-warriors/giorgio-samaraid':
    'Giorgio Samaraid',
  'player.great-britain/scottish-league/celtic-warriors/scottie-vision':
    'Scottie Vision',
  'player.great-britain/scottish-league/celtic-warriors/mikael-lustylad':
    'Mikael LustyLad',
  'player.great-britain/scottish-league/celtic-warriors/jon-stronghart':
    'Jon StrongHart',
  'player.great-britain/scottish-league/celtic-warriors/celtic-king':
    'Celtic King',
  'player.great-britain/english-league/diamond-dogs/gabi-luna': 'Gabi Luna',
  'player.great-britain/english-league/diamond-dogs/richard-zorehkey':
    'Richard Zorehkey',
  'player.great-britain/english-league/diamond-dogs/isaac-mcadoo':
    'Isaac McAdoo',
  'player.great-britain/english-league/diamond-dogs/leslie-higgins':
    'Leslie Higgins',
  'player.great-britain/english-league/diamond-dogs/colin-hughes':
    'Colin Hughes',
  'player.great-britain/english-league/diamond-dogs/jan-maas': 'Jan Maas',
  'player.great-britain/english-league/diamond-dogs/renee-kent': 'Renee Kent',
  'player.great-britain/english-league/diamond-dogs/thierry-zorehkey':
    'Thierry Zorehkey',
  'player.great-britain/english-league/diamond-dogs/daniela-rojas':
    'Daniela Rojas',
  'player.great-britain/english-league/diamond-dogs/samantha-obisanya':
    'Samantha Obisanya',
  'player.great-britain/english-league/diamond-dogs/james-taylor':
    'James Taylor',
  'player.great-britain/english-league/diamond-dogs/alfie-guzman':
    'Alfie Guzman',
  'player.great-britain/english-league/diamond-dogs/ben-johnson': 'Ben Johnson',
  'player.great-britain/english-league/diamond-dogs/kyle-mcroy': 'Kyle McRoy',
  'player.great-britain/english-league/diamond-dogs/declan-oconnell':
    "Declan O'Connell",
  'player.great-britain/english-league/diamond-dogs/jeff-goodman':
    'Jeff Goodman',
  'player.great-britain/english-league/diamond-dogs/moe-bumbercatch':
    'Moe Bumbercatch',
  'player.great-britain/english-league/diamond-dogs/tomáš-kukoč': 'Tomáš Kukoč',
  'player.great-britain/english-league/diamond-dogs/jean-philippe-van-damme':
    'Jean-Philippe Van Damme',
  'player.great-britain/english-league/diamond-dogs/paul-reynolds':
    'Paul Reynolds',
  'player.great-britain/english-league/night-watch/samwell-beadle':
    'Samwell Beadle',
  'player.great-britain/english-league/night-watch/ygritte-palmer':
    'Ygritte Palmer',
  'player.great-britain/english-league/night-watch/arya-delgado':
    'Arya Delgado',
  'player.great-britain/english-league/night-watch/brandon-valentin':
    'Brandon Valentin',
  'player.great-britain/english-league/night-watch/sansa-bannan':
    'Sansa Bannan',
  'player.great-britain/english-league/night-watch/tormund-nilsson':
    'Tormund Nilsson',
  'player.great-britain/english-league/night-watch/eddison-windass':
    'Eddison Windass',
  'player.great-britain/english-league/night-watch/lyanna-pressman':
    'Lyanna Pressman',
  'player.great-britain/english-league/night-watch/mance-ugbo': 'Mance Ugbo',
  'player.great-britain/english-league/night-watch/benjen-bannan':
    'Benjen Bannan',
  'player.great-britain/english-league/night-watch/jon-waddle': 'Jon Waddle',
  'player.great-britain/english-league/night-watch/gendry-waters':
    'Gendry Waters',
  'player.great-britain/english-league/night-watch/jeor-sheridan':
    'Jeor Sheridan',
  'player.great-britain/english-league/night-watch/pyp-hirst': 'Pyp Hirst',
  'player.great-britain/english-league/night-watch/grenn-walker':
    'Grenn Walker',
  'player.great-britain/english-league/night-watch/maester-di-canio':
    'Maester Di Canio',
  'player.great-britain/english-league/night-watch/osha-woods': 'Osha Woods',
  'player.great-britain/english-league/night-watch/dolorous-westwood':
    'Dolorous Westwood',
  'player.great-britain/english-league/night-watch/alliser-bright':
    'Alliser Bright',
  'player.great-britain/english-league/night-watch/qhorin-diaby':
    'Qhorin Diaby',
  'player.great-britain/english-league/gull-pride/alex-rivera': 'Alex Rivera',
  'player.great-britain/english-league/gull-pride/jordan-kim': 'Jordan Kim',
  'player.great-britain/english-league/gull-pride/sam-taylor': 'Sam Taylor',
  'player.great-britain/english-league/gull-pride/jamie-lee': 'Jamie Lee',
  'player.great-britain/english-league/gull-pride/morgan-patil': 'Morgan Patil',
  'player.great-britain/english-league/gull-pride/taylor-“tj”-james':
    'Taylor “TJ” James',
  'player.great-britain/english-league/gull-pride/casey-smith': 'Casey Smith',
  'player.great-britain/english-league/gull-pride/luca-martinez':
    'Luca Martinez',
  'player.great-britain/english-league/gull-pride/sasha-ivanov': 'Sasha Ivanov',
  'player.great-britain/english-league/gull-pride/niko-garcía': 'Niko García',
  'player.great-britain/english-league/gull-pride/arielle-dupont':
    'Arielle Dupont',
  'player.great-britain/english-league/gull-pride/ben-williams': 'Ben Williams',
  'player.great-britain/english-league/gull-pride/chloe-davis': 'Chloe Davis',
  'player.great-britain/english-league/gull-pride/marcus-adebayo':
    'Marcus Adebayo',
  'player.great-britain/english-league/gull-pride/sofia-eriksson':
    'Sofia Eriksson',
  'player.great-britain/english-league/gull-pride/kenji-tanaka': 'Kenji Tanaka',
  'player.great-britain/english-league/gull-pride/olivia-murphy':
    'Olivia Murphy',
  'player.great-britain/english-league/gull-pride/ethan-miller': 'Ethan Miller',
  'player.great-britain/english-league/gull-pride/isabelle-dubois':
    'Isabelle Dubois',
  'player.great-britain/english-league/london-blues/roberta-sánchez':
    'Roberta Sánchez',
  'player.great-britain/english-league/london-blues/rebecca-james':
    'Rebecca James',
  'player.great-britain/english-league/london-blues/wesley-franco':
    'Wesley Franco',
  'player.great-britain/english-league/london-blues/thierry-santos':
    'Thierry Santos',
  'player.great-britain/english-league/london-blues/martin-cucurella':
    'Martin Cucurella',
  'player.great-britain/english-league/london-blues/mykhaila-martyn':
    'Mykhaila Martyn',
  'player.great-britain/english-league/london-blues/esmine-flores':
    'Esmine Flores',
  'player.great-britain/english-league/london-blues/greg-connors':
    'Greg Connors',
  'player.great-britain/english-league/london-blues/rae-smith': 'Rae Smith',
  'player.great-britain/english-league/london-blues/christina-nkunku':
    'Christina Nkunku',
  'player.great-britain/english-league/london-blues/nicole-jones':
    'Nicole Jones',
  'player.great-britain/english-league/london-blues/malia-gusteau':
    'Malia Gusteau',
  'player.great-britain/english-league/london-blues/levia-colwillow':
    'Levia Colwillow',
  'player.great-britain/english-league/london-blues/axelle-disas':
    'Axelle Disas',
  'player.great-britain/english-league/london-blues/moira-caidero':
    'Moira Caidero',
  'player.great-britain/english-league/london-blues/romana-lavia':
    'Romana Lavia',
  'player.great-britain/english-league/london-blues/coleen-palmera':
    'Coleen Palmera',
  'player.great-britain/english-league/london-blues/nonie-maduekwe':
    'Nonie Maduekwe',
  'player.great-britain/english-league/london-blues/armanda-broja':
    'Armanda Broja',
  'player.great-britain/english-league/london-blues/petra-petrova':
    'Petra Petrova',
  'player.great-britain/english-league/hellhounds/andrea-earps': 'Andrea Earps',
  'player.great-britain/english-league/hellhounds/hannah-dalot': 'Hannah Dalot',
  'player.great-britain/english-league/hellhounds/millie-martínez':
    'Millie Martínez',
  'player.great-britain/english-league/hellhounds/hayley-maguire':
    'Hayley Maguire',
  'player.great-britain/english-league/hellhounds/luke-le-tissier':
    'Luke Le Tissier',
  'player.great-britain/english-league/hellhounds/mcterminator': 'McTerminator',
  'player.great-britain/english-league/hellhounds/ella-fernandes':
    'Ella Fernandes',
  'player.great-britain/english-league/hellhounds/katie-mainoo': 'Katie Mainoo',
  'player.great-britain/english-league/hellhounds/marcus-russo': 'Marcus Russo',
  'player.great-britain/english-league/hellhounds/rasmus-parris':
    'Rasmus Parris',
  'player.great-britain/english-league/hellhounds/lucia-garnacho':
    'Lucia Garnacho',
  'player.great-britain/english-league/hellhounds/sophie-wan-aaron':
    'Sophie Wan-Aaron',
  'player.great-britain/english-league/hellhounds/rafaelle-mannion':
    'Rafaelle Mannion',
  'player.great-britain/english-league/hellhounds/cassie-emery': 'Cassie Emery',
  'player.great-britain/english-league/hellhounds/christina-eriksen':
    'Christina Eriksen',
  'player.great-britain/english-league/hellhounds/maisie-mountford':
    'Maisie Mountford',
  'player.great-britain/english-league/hellhounds/antonia-ferreira':
    'Antonia Ferreira',
  'player.great-britain/english-league/hellhounds/gemma-lindelof':
    'Gemma Lindelof',
  'player.great-britain/english-league/hellhounds/anthony-williams':
    'Anthony Williams',
  'player.great-britain/english-league/hellhounds/altay-baggaley':
    'Altay Baggaley',
  'player.great-britain/english-league/knights-forge/pia-martino':
    'Pia Martino',
  'player.great-britain/english-league/knights-forge/robbie-macallister':
    'Robbie MacAllister',
  'player.great-britain/english-league/knights-forge/julianne-dicks':
    'Julianne Dicks',
  'player.great-britain/english-league/knights-forge/sir-bobby': 'Sir Bobby',
  'player.great-britain/english-league/knights-forge/victoria-bonds':
    'Victoria Bonds',
  'player.great-britain/english-league/knights-forge/martina-allen':
    'Martina Allen',
  'player.great-britain/english-league/knights-forge/sir-trevor': 'Sir Trevor',
  'player.great-britain/english-league/knights-forge/lennox-devonshire':
    'Lennox Devonshire',
  'player.great-britain/english-league/knights-forge/sir-geoff': 'Sir Geoff',
  'player.great-britain/english-league/knights-forge/paula-di-canio':
    'Paula Di Canio',
  'player.great-britain/english-league/knights-forge/carla-cole': 'Carla Cole',
  'player.great-britain/english-league/knights-forge/michelle-antonio':
    'Michelle Antonio',
  'player.great-britain/english-league/knights-forge/jarra-bowen':
    'Jarra Bowen',
  'player.great-britain/english-league/knights-forge/danielle-rice':
    'Danielle Rice',
  'player.great-britain/english-league/knights-forge/martha-noble':
    'Martha Noble',
  'player.great-britain/english-league/knights-forge/antonia-cottee':
    'Antonia Cottee',
  'player.great-britain/english-league/knights-forge/alvina-martin':
    'Alvina Martin',
  'player.great-britain/english-league/knights-forge/francesca-lampard':
    'Francesca Lampard',
  'player.great-britain/english-league/knights-forge/stephanie-potts':
    'Stephanie Potts',
  'player.great-britain/english-league/knights-forge/ludmilla-miklosko':
    'Ludmilla Miklosko',
  'player.great-britain/english-league/villains/emily-martins': 'Emily Martins',
  'player.great-britain/english-league/villains/matthew-chasen':
    'Matthew Chasen',
  'player.great-britain/english-league/villains/tyra-minga': 'Tyra Minga',
  'player.great-britain/english-league/villains/ezrianna-konsa':
    'Ezrianna Konsa',
  'player.great-britain/english-league/villains/lucas-digney': 'Lucas Digney',
  'player.great-britain/english-league/villains/jacqueline-galloway':
    'Jacqueline Galloway',
  'player.great-britain/english-league/villains/douglas-luísa': 'Douglas Luísa',
  'player.great-britain/english-league/villains/bertie-traoré': 'Bertie Traoré',
  'player.great-britain/english-league/villains/olivia-watkins':
    'Olivia Watkins',
  'player.great-britain/english-league/villains/leon-bailey': 'Leon Bailey',
  'player.great-britain/english-league/villains/johanna-mcginn':
    'Johanna McGinn',
  'player.great-britain/english-league/villains/paula-torres': 'Paula Torres',
  'player.great-britain/english-league/villains/diega-carla': 'Diega Carla',
  'player.great-britain/english-league/villains/alexa-moreno': 'Alexa Moreno',
  'player.great-britain/english-league/villains/boubacara-kamara':
    'Boubacara Kamara',
  'player.great-britain/english-league/villains/youria-tielemans':
    'Youria Tielemans',
  'player.great-britain/english-league/villains/moussa-diabate':
    'Moussa Diabate',
  'player.great-britain/english-league/villains/jhonnia-durán': 'Jhonnia Durán',
  'player.great-britain/english-league/villains/nicola-zaniola':
    'Nicola Zaniola',
  'player.great-britain/english-league/villains/robin-olsen': 'Robin Olsen',
  'player.great-britain/english-league/vixens/kat-schmeichel': 'Kat Schmeichel',
  'player.great-britain/english-league/vixens/danielle-simpson':
    'Danielle Simpson',
  'player.great-britain/english-league/vixens/christina-fuchs':
    'Christina Fuchs',
  'player.great-britain/english-league/vixens/wendy-morgan': 'Wendy Morgan',
  'player.great-britain/english-league/vixens/roberta-huth': 'Roberta Huth',
  'player.great-britain/english-league/vixens/riya-mahrez': 'Riya Mahrez',
  'player.great-britain/english-league/vixens/danielle-drinkwater':
    'Danielle Drinkwater',
  'player.great-britain/english-league/vixens/natalia-kante': 'Natalia Kante',
  'player.great-britain/english-league/vixens/madeleine-albrighton':
    'Madeleine Albrighton',
  'player.great-britain/english-league/vixens/sasha-okazaki': 'Sasha Okazaki',
  'player.great-britain/english-league/vixens/gemma-vardy': 'Gemma Vardy',
  'player.great-britain/english-league/vixens/leonarda-ulloa': 'Leonarda Ulloa',
  'player.great-britain/english-league/vixens/andrea-king': 'Andrea King',
  'player.great-britain/english-league/vixens/jessica-schlupp':
    'Jessica Schlupp',
  'player.great-britain/english-league/vixens/nathan-dwyer': 'Nathan Dwyer',
  'player.great-britain/english-league/vixens/marcia-wasilewski':
    'Marcia Wasilewski',
  'player.great-britain/english-league/vixens/gokhana-inler': 'Gokhana Inler',
  'player.great-britain/english-league/vixens/demara-gray': 'Demara Gray',
  'player.great-britain/english-league/vixens/danielle-amartey':
    'Danielle Amartey',
  'player.great-britain/english-league/vixens/marcia-schwarzer':
    'Marcia Schwarzer',
  'player.great-britain/english-league/sherwood-forest/friar-shilton':
    'Friar Shilton',
  'player.great-britain/english-league/sherwood-forest/vivian-scarlet':
    'Vivian Scarlet',
  'player.great-britain/english-league/sherwood-forest/alan-a-dale':
    'Alan-a-Dale',
  'player.great-britain/english-league/sherwood-forest/little-des':
    'Little Des',
  'player.great-britain/english-league/sherwood-forest/brother-tuck':
    'Brother Tuck',
  'player.great-britain/english-league/sherwood-forest/much-the-millers-son':
    "Much the Miller's Son",
  'player.great-britain/english-league/sherwood-forest/robin-hood':
    'Robin Hood',
  'player.great-britain/english-league/sherwood-forest/lady-cluck':
    'Lady Cluck',
  'player.great-britain/english-league/sherwood-forest/gilbert-whitehand':
    'Gilbert Whitehand',
  'player.great-britain/english-league/sherwood-forest/eleanor-dale':
    'Eleanor Dale',
  'player.great-britain/english-league/sherwood-forest/maid-marian':
    'Maid Marian',
  'player.great-britain/english-league/sherwood-forest/kenny-byrne':
    'Kenny Byrne',
  'player.great-britain/english-league/sherwood-forest/martina-omalley':
    "Martina O'Malley",
  'player.great-britain/english-league/sherwood-forest/laurie-lloyd':
    'Laurie Lloyd',
  'player.great-britain/english-league/sherwood-forest/archie-gemstone':
    'Archie Gemstone',
  'player.great-britain/english-league/sherwood-forest/petra-withe':
    'Petra Withe',
  'player.great-britain/english-league/sherwood-forest/joanne-mcgovern':
    'Joanne McGovern',
  'player.great-britain/english-league/sherwood-forest/frances-clark':
    'Frances Clark',
  'player.great-britain/english-league/sherwood-forest/carrie-birtles':
    'Carrie Birtles',
  'player.great-britain/english-league/sherwood-forest/davina-hodge':
    'Davina Hodge',
  'player.great-britain/english-league/mersey-phoenix/alice-becker':
    'Alice Becker',
  'player.great-britain/english-league/mersey-phoenix/trisha-alexander-arnold':
    'Trisha Alexander-Arnold',
  'player.great-britain/english-league/mersey-phoenix/virgilia-van-dijk':
    'Virgilia van Dijk',
  'player.great-britain/english-league/mersey-phoenix/josephine-gomez':
    'Josephine Gomez',
  'player.great-britain/english-league/mersey-phoenix/andrea-robertson':
    'Andrea Robertson',
  'player.great-britain/english-league/mersey-phoenix/watara-endo':
    'Watara Endo',
  'player.great-britain/english-league/mersey-phoenix/alexia-macallister':
    'Alexia MacAllister',
  'player.great-britain/english-league/mersey-phoenix/ryana-gravenberch':
    'Ryana Gravenberch',
  'player.great-britain/english-league/mersey-phoenix/maureen-salah':
    'Maureen Salah',
  'player.great-britain/english-league/mersey-phoenix/darwina-núñez':
    'Darwina Núñez',
  'player.great-britain/english-league/mersey-phoenix/luisa-díaz': 'Luisa Díaz',
  'player.great-britain/english-league/mersey-phoenix/ibrahima-konatey':
    'Ibrahima Konatey',
  'player.great-britain/english-league/mersey-phoenix/dominica-szoboszlai':
    'Dominica Szoboszlai',
  'player.great-britain/english-league/mersey-phoenix/chase-jones':
    'Chase Jones',
  'player.great-britain/english-league/mersey-phoenix/harriet-elliott':
    'Harriet Elliott',
  'player.great-britain/english-league/mersey-phoenix/dominique-jota':
    'Dominique Jota',
  'player.great-britain/english-league/mersey-phoenix/cherry-gakpa':
    'Cherry Gakpa',
  'player.great-britain/english-league/mersey-phoenix/kristina-tsimikas':
    'Kristina Tsimikas',
  'player.great-britain/english-league/mersey-phoenix/connie-kelleher':
    'Connie Kelleher',
  'player.great-britain/english-league/mersey-phoenix/kevin-bradley':
    'Kevin Bradley',
  'player.great-britain/english-league/oil-fc/eduarda-souza': 'Eduarda Souza',
  'player.great-britain/english-league/oil-fc/karla-walton': 'Karla Walton',
  'player.great-britain/english-league/oil-fc/nathalia-aké': 'Nathalia Aké',
  'player.great-britain/english-league/oil-fc/rafaela-duarte': 'Rafaela Duarte',
  'player.great-britain/english-league/oil-fc/manuela-akanji': 'Manuela Akanji',
  'player.great-britain/english-league/oil-fc/rita-ramos': 'Rita Ramos',
  'player.great-britain/english-league/oil-fc/matea-kovačić': 'Matea Kovačić',
  'player.great-britain/english-league/oil-fc/isabelle-dujardin':
    'Isabelle Dujardin',
  'player.great-britain/english-league/oil-fc/fernanda-foster':
    'Fernanda Foster',
  'player.great-britain/english-league/oil-fc/helena-halvorsen':
    'Helena Halvorsen',
  'player.great-britain/english-league/oil-fc/julia-greenway': 'Julia Greenway',
  'player.great-britain/english-league/oil-fc/johanna-stones': 'Johanna Stones',
  'player.great-britain/english-league/oil-fc/joska-gvardiol': 'Joska Gvardiol',
  'player.great-britain/english-league/oil-fc/ricarda-lewis': 'Ricarda Lewis',
  'player.great-britain/english-league/oil-fc/matilda-nunes': 'Matilda Nunes',
  'player.great-britain/english-league/oil-fc/bernice-silva': 'Bernice Silva',
  'player.great-britain/english-league/oil-fc/jeremia-doku': 'Jeremia Doku',
  'player.great-britain/english-league/oil-fc/juliana-álvarez':
    'Juliana Álvarez',
  'player.great-britain/english-league/oil-fc/oscaria-bobb': 'Oscaria Bobb',
  'player.great-britain/english-league/oil-fc/stefania-ortega':
    'Stefania Ortega',
  'player.great-britain/english-league/invincibles/jasmin-lens': 'Jasmin Lens',
  'player.great-britain/english-league/invincibles/lauren-cooper':
    'Lauren Cooper',
  'player.great-britain/english-league/invincibles/kaylie-tourette':
    'Kaylie Tourette',
  'player.great-britain/english-league/invincibles/titanium': 'Titanium',
  'player.great-britain/english-league/invincibles/granite': 'Granite',
  'player.great-britain/english-league/invincibles/fredrik-ljindersson':
    'Fredrik Ljindersson',
  'player.great-britain/english-league/invincibles/obsidian': 'Obsidian',
  'player.great-britain/english-league/invincibles/gilberto-silvana':
    'Gilberto Silvana',
  'player.great-britain/english-league/invincibles/roberta-perrin':
    'Roberta Perrin',
  'player.great-britain/english-league/invincibles/steel': 'Steel',
  'player.great-britain/english-league/invincibles/ice': 'Ice',
  'player.great-britain/english-league/invincibles/edwina-gaspar':
    'Edwina Gaspar',
  'player.great-britain/english-league/invincibles/rae-parlour': 'Rae Parlour',
  'player.great-britain/english-league/invincibles/sylvie-wiltord':
    'Sylvie Wiltord',
  'player.great-britain/english-league/invincibles/nancy-kanu': 'Nancy Kanu',
  'player.great-britain/english-league/invincibles/pascalina-cyganne':
    'Pascalina Cyganne',
  'player.great-britain/english-league/invincibles/gail-clichy': 'Gail Clichy',
  'player.great-britain/english-league/invincibles/josephine-reyes':
    'Josephine Reyes',
  'player.great-britain/english-league/invincibles/marian-keown':
    'Marian Keown',
  'player.great-britain/english-league/invincibles/manuela-almunia':
    'Manuela Almunia',
  'player.great-britain/english-league/mersey-mullets/spaghetti-grobbs':
    'Spaghetti Grobbs',
  'player.great-britain/english-league/mersey-mullets/phil-kingston':
    'Phil Kingston',
  'player.great-britain/english-league/mersey-mullets/steve-mccann':
    'Steve McCann',
  'player.great-britain/english-league/mersey-mullets/alan-murdoch':
    'Alan Murdoch',
  'player.great-britain/english-league/mersey-mullets/kenneth-arthur':
    'Kenneth Arthur',
  'player.great-britain/english-league/mersey-mullets/mad-mullet': 'Mad Mullet',
  'player.great-britain/english-league/mersey-mullets/simon-dalby':
    'Simon Dalby',
  'player.great-britain/english-league/mersey-mullets/red-king': 'Red King',
  'player.great-britain/english-league/mersey-mullets/moustached-marvel':
    'Moustached Marvel',
  'player.great-britain/english-league/mersey-mullets/john-walker':
    'John Walker',
  'player.great-britain/english-league/mersey-mullets/craig-mcallister':
    'Craig McAllister',
  'player.great-britain/english-league/mersey-mullets/ronalda-whelan':
    'Ronalda Whelan',
  'player.great-britain/english-league/mersey-mullets/michaela-robinson':
    'Michaela Robinson',
  'player.great-britain/english-league/mersey-mullets/stephanie-nicol':
    'Stephanie Nicol',
  'player.great-britain/english-league/mersey-mullets/janine-molby':
    'Janine Molby',
  'player.great-britain/english-league/mersey-mullets/gabriella-gillespie':
    'Gabriella Gillespie',
  'player.great-britain/english-league/mersey-mullets/davina-hodgson':
    'Davina Hodgson',
  'player.great-britain/english-league/mersey-mullets/phillipa-thompson':
    'Phillipa Thompson',
  'player.great-britain/english-league/mersey-mullets/camilla-case':
    'Camilla Case',
  'player.great-britain/english-league/mersey-mullets/roberta-bolder':
    'Roberta Bolder',
  'player.great-britain/english-league/treble-devils/great-dane': 'Great Dane',
  'player.great-britain/english-league/treble-devils/gary-phillips':
    'Gary Phillips',
  'player.great-britain/english-league/treble-devils/jens-stan': 'Jens Stan',
  'player.great-britain/english-league/treble-devils/john-ronsen':
    'John Ronsen',
  'player.great-britain/english-league/treble-devils/dennis-keane':
    'Dennis Keane',
  'player.great-britain/english-league/treble-devils/red-devil': 'Red Devil',
  'player.great-britain/english-league/treble-devils/golden-boy': 'Golden Boy',
  'player.great-britain/english-league/treble-devils/ginger-ninja':
    'Ginger Ninja',
  'player.great-britain/english-league/treble-devils/andy-goals': 'Andy Goals',
  'player.great-britain/english-league/treble-devils/david-yorke':
    'David Yorke',
  'player.great-britain/english-league/treble-devils/welsh-wizard':
    'Welsh Wizard',
  'player.great-britain/english-league/treble-devils/baby-faced-assassin':
    'Baby Faced Assassin',
  'player.great-britain/english-league/treble-devils/nicky-bottom':
    'Nicky Bottom',
  'player.great-britain/english-league/treble-devils/phillip-garyson':
    'Phillip Garyson',
  'player.great-britain/english-league/treble-devils/henrietta-berg':
    'Henrietta Berg',
  'player.great-britain/english-league/treble-devils/teddy-bear': 'Teddy Bear',
  'player.great-britain/english-league/treble-devils/jessie-blomqvist':
    'Jessie Blomqvist',
  'player.great-britain/english-league/treble-devils/wes-green': 'Wes Green',
  'player.great-britain/english-league/treble-devils/jonathan-cruyff':
    'Jonathan Cruyff',
  'player.great-britain/english-league/treble-devils/petra-van-der-garde':
    'Petra Van Der Garde',
  'player.south-europe/italian-league/toro-infucato/leonardo-marcatelli':
    'Leonardo Marcatelli',
  'player.south-europe/italian-league/toro-infucato/piero-bravi': 'Piero Bravi',
  'player.south-europe/italian-league/toro-infucato/romano-calvetti':
    'Romano Calvetti',
  'player.south-europe/italian-league/toro-infucato/riccardo-montesi':
    'Riccardo Montesi',
  'player.south-europe/italian-league/toro-infucato/leonardo-ferrini':
    'Leonardo Ferrini',
  'player.south-europe/italian-league/toro-infucato/ezio-scintilla':
    'Ezio Scintilla',
  'player.south-europe/italian-league/toro-infucato/rafael-marquez-velasquez':
    'Rafael Marquez Velasquez',
  'player.south-europe/italian-league/toro-infucato/salvatore-corsini':
    'Salvatore Corsini',
  'player.south-europe/italian-league/toro-infucato/esteban-alvarez':
    'Esteban Alvarez',
  'player.south-europe/italian-league/toro-infucato/guglielmo-lazzarini':
    'Guglielmo Lazzarini',
  'player.south-europe/italian-league/toro-infucato/gabriele-bresci':
    'Gabriele Bresci',
  'player.south-europe/italian-league/toro-infucato/riccardo-de-francesco':
    'Riccardo De Francesco',
  'player.south-europe/italian-league/toro-infucato/enrico-annoni':
    'Enrico Annoni',
  'player.south-europe/italian-league/toro-infucato/gianluca-sordo':
    'Gianluca Sordo',
  'player.south-europe/italian-league/toro-infucato/walter-casatoro':
    'Walter Casatoro',
  'player.south-europe/italian-league/toro-infucato/silvano-benedetto':
    'Silvano Benedetto',
  'player.south-europe/italian-league/toro-infucato/giorgio-venturini':
    'Giorgio Venturini',
  'player.south-europe/italian-league/toro-infucato/daniele-fortunato':
    'Daniele Fortunato',
  'player.south-europe/italian-league/toro-infucato/giuseppe-carillo':
    'Giuseppe Carillo',
  'player.south-europe/italian-league/toro-infucato/paolo-taurino':
    'Paolo Taurino',
  'player.south-europe/italian-league/toro-infucato/christiano-bobo':
    'Christiano Bobo',
  'player.south-europe/italian-league/giglio-ardente/franca-bellini':
    'Franca Bellini',
  'player.south-europe/italian-league/giglio-ardente/luca-repko': 'Luca Repko',
  'player.south-europe/italian-league/giglio-ardente/moreno-torelli':
    'Moreno Torelli',
  'player.south-europe/italian-league/giglio-ardente/stefania-bertini':
    'Stefania Bertini',
  'player.south-europe/italian-league/giglio-ardente/pasqualina-padovano':
    'Pasqualina Padovano',
  'player.south-europe/italian-league/giglio-ardente/guillermo-amora':
    'Guillermo Amora',
  'player.south-europe/italian-league/giglio-ardente/emilia-bigatti':
    'Emilia Bigatti',
  'player.south-europe/italian-league/giglio-ardente/rita-costa': 'Rita Costa',
  'player.south-europe/italian-league/giglio-ardente/batigol': 'Batigol',
  'player.south-europe/italian-league/giglio-ardente/eduarda': 'Eduarda',
  'player.south-europe/italian-league/giglio-ardente/luisa-olivieri':
    'Luisa Olivieri',
  'player.south-europe/italian-league/giglio-ardente/alessandra-zandoni':
    'Alessandra Zandoni',
  'player.south-europe/italian-league/giglio-ardente/georgina-heinrich':
    'Georgina Heinrich',
  'player.south-europe/italian-league/giglio-ardente/stefania-schwarz':
    'Stefania Schwarz',
  'player.south-europe/italian-league/giglio-ardente/sandra-cois':
    'Sandra Cois',
  'player.south-europe/italian-league/giglio-ardente/andrea-tarozza':
    'Andrea Tarozza',
  'player.south-europe/italian-league/giglio-ardente/christiana-amorosa':
    'Christiana Amorosa',
  'player.south-europe/italian-league/giglio-ardente/francesca-flachia':
    'Francesca Flachia',
  'player.south-europe/italian-league/giglio-ardente/anselma-robbiata':
    'Anselma Robbiata',
  'player.south-europe/italian-league/giglio-ardente/giuseppina-taglia':
    'Giuseppina Taglia',
  'player.south-europe/italian-league/tornado-gialloblu/giada-bufalini':
    'Giada Bufalini',
  'player.south-europe/italian-league/tornado-gialloblu/annalisa-benatti':
    'Annalisa Benatti',
  'player.south-europe/italian-league/tornado-gialloblu/lorena-sarto':
    'Lorena Sarto',
  'player.south-europe/italian-league/tornado-gialloblu/federico-cantoro':
    'Federico Cantoro',
  'player.south-europe/italian-league/tornado-gialloblu/liane-turam':
    'Liane Turam',
  'player.south-europe/italian-league/tornado-gialloblu/delia-bagnoli':
    'Delia Bagnoli',
  'player.south-europe/italian-league/tornado-gialloblu/denis-fusco':
    'Denis Fusco',
  'player.south-europe/italian-league/tornado-gialloblu/julia-s.-verona':
    'Julia S. Verona',
  'player.south-europe/italian-league/tornado-gialloblu/lionel-sensi':
    'Lionel Sensi',
  'player.south-europe/italian-league/tornado-gialloblu/elena-chiesi':
    'Elena Chiesi',
  'player.south-europe/italian-league/tornado-gialloblu/helena-crespi':
    'Helena Crespi',
  'player.south-europe/italian-league/tornado-gialloblu/alize-bohos':
    'Alize Bohos',
  'player.south-europe/italian-league/tornado-gialloblu/maria-stanici':
    'Maria Stanici',
  'player.south-europe/italian-league/tornado-gialloblu/paola-vanoli':
    'Paola Vanoli',
  'player.south-europe/italian-league/tornado-gialloblu/stefania-fiori':
    'Stefania Fiori',
  'player.south-europe/italian-league/tornado-gialloblu/salia-lassisi':
    'Salia Lassisi',
  'player.south-europe/italian-league/tornado-gialloblu/roberta-mussi':
    'Roberta Mussi',
  'player.south-europe/italian-league/tornado-gialloblu/raffaella-longa':
    'Raffaella Longa',
  'player.south-europe/italian-league/tornado-gialloblu/petra-strada':
    'Petra Strada',
  'player.south-europe/italian-league/tornado-gialloblu/mattea-guardalbeni':
    'Mattea Guardalbeni',
  'player.south-europe/italian-league/rettili-nerazzurri/salvo-pellegrini':
    'Salvo Pellegrini',
  'player.south-europe/italian-league/rettili-nerazzurri/julio-zanatta':
    'Julio Zanatta',
  'player.south-europe/italian-league/rettili-nerazzurri/tino-westini':
    'Tino Westini',
  'player.south-europe/italian-league/rettili-nerazzurri/giorgio-bergato':
    'Giorgio Bergato',
  'player.south-europe/italian-league/rettili-nerazzurri/fernando-galiardo':
    'Fernando Galiardo',
  'player.south-europe/italian-league/rettili-nerazzurri/alessio-winteri':
    'Alessio Winteri',
  'player.south-europe/italian-league/rettili-nerazzurri/alvaro-recalda':
    'Alvaro Recalda',
  'player.south-europe/italian-league/rettili-nerazzurri/diego-simero':
    'Diego Simero',
  'player.south-europe/italian-league/rettili-nerazzurri/ismael-zambrana':
    'Ismael Zambrana',
  'player.south-europe/italian-league/rettili-nerazzurri/ronaldo-lizario':
    'Ronaldo Lizario',
  'player.south-europe/italian-league/rettili-nerazzurri/yves-djorkscale':
    'Yves Djorkscale',
  'player.south-europe/italian-league/rettili-nerazzurri/angelo-mazzini':
    'Angelo Mazzini',
  'player.south-europe/italian-league/rettili-nerazzurri/franco-mordini':
    'Franco Mordini',
  'player.south-europe/italian-league/rettili-nerazzurri/ben-cauetti':
    'Ben Cauetti',
  'player.south-europe/italian-league/rettili-nerazzurri/sal-fresini':
    'Sal Fresini',
  'player.south-europe/italian-league/rettili-nerazzurri/luigi-sartori':
    'Luigi Sartori',
  'player.south-europe/italian-league/rettili-nerazzurri/nwan-kanuni':
    'Nwan Kanuni',
  'player.south-europe/italian-league/rettili-nerazzurri/ze-elia': 'Ze Elia',
  'player.south-europe/italian-league/rettili-nerazzurri/paolo-sousini':
    'Paolo Sousini',
  'player.south-europe/italian-league/rettili-nerazzurri/franco-colonnini':
    'Franco Colonnini',
  'player.south-europe/italian-league/tritoni-blucerchiati/gavino-palumbo':
    'Gavino Palumbo',
  'player.south-europe/italian-league/tritoni-blucerchiati/maresco-mannetti':
    'Maresco Mannetti',
  'player.south-europe/italian-league/tritoni-blucerchiati/filippo-colvetti':
    'Filippo Colvetti',
  'player.south-europe/italian-league/tritoni-blucerchiati/cesare-ferretti':
    'Cesare Ferretti',
  'player.south-europe/italian-league/tritoni-blucerchiati/pietro-ventola':
    'Pietro Ventola',
  'player.south-europe/italian-league/tritoni-blucerchiati/adriano-lombarda':
    'Adriano Lombarda',
  'player.south-europe/italian-league/tritoni-blucerchiati/roberto-mareni':
    'Roberto Mareni',
  'player.south-europe/italian-league/tritoni-blucerchiati/tonio-pescatore':
    'Tonio Pescatore',
  'player.south-europe/italian-league/tritoni-blucerchiati/luigi-fuso':
    'Luigi Fuso',
  'player.south-europe/italian-league/tritoni-blucerchiati/giorgio-vialle':
    'Giorgio Vialle',
  'player.south-europe/italian-league/tritoni-blucerchiati/fausto-sireno':
    'Fausto Sireno',
  'player.south-europe/italian-league/tritoni-blucerchiati/oleksiy-mykha':
    'Oleksiy Mykha',
  'player.south-europe/italian-league/tritoni-blucerchiati/marco-branchini':
    'Marco Branchini',
  'player.south-europe/italian-league/tritoni-blucerchiati/giovanni-inverni':
    'Giovanni Inverni',
  'player.south-europe/italian-league/tritoni-blucerchiati/ivano-bonetto':
    'Ivano Bonetto',
  'player.south-europe/italian-league/tritoni-blucerchiati/giuseppe-dosseni':
    'Giuseppe Dosseni',
  'player.south-europe/italian-league/tritoni-blucerchiati/victor-munoz':
    'Victor Munoz',
  'player.south-europe/italian-league/tritoni-blucerchiati/marco-lannini':
    'Marco Lannini',
  'player.south-europe/italian-league/tritoni-blucerchiati/paulo-silvino':
    'Paulo Silvino',
  'player.south-europe/italian-league/tritoni-blucerchiati/julio-cesare':
    'Julio Cesare',
  'player.south-europe/italian-league/squadra-partenopea/rafaela-di-francesco':
    'Rafaela Di Francesco',
  'player.south-europe/italian-league/squadra-partenopea/marco-belloni':
    'Marco Belloni',
  'player.south-europe/italian-league/squadra-partenopea/claudia-ferraro':
    'Claudia Ferraro',
  'player.south-europe/italian-league/squadra-partenopea/giovanni-francini':
    'Giovanni Francini',
  'player.south-europe/italian-league/squadra-partenopea/teresa-silvestri':
    'Teresa Silvestri',
  'player.south-europe/italian-league/squadra-partenopea/alessandro-renica':
    'Alessandro Renica',
  'player.south-europe/italian-league/squadra-partenopea/aleixo': 'Aleixo',
  'player.south-europe/italian-league/squadra-partenopea/fernanda-de-napolitano':
    'Fernanda De Napolitano',
  'player.south-europe/italian-league/squadra-partenopea/massima-crippa':
    'Massima Crippa',
  'player.south-europe/italian-league/squadra-partenopea/carina': 'Carina',
  'player.south-europe/italian-league/squadra-partenopea/hand-of-god':
    'Hand Of God',
  'player.south-europe/italian-league/squadra-partenopea/andrea-carnivale':
    'Andrea Carnivale',
  'player.south-europe/italian-league/squadra-partenopea/gianni-zola':
    'Gianni Zola',
  'player.south-europe/italian-league/squadra-partenopea/massimo-maurini':
    'Massimo Maurini',
  'player.south-europe/italian-league/squadra-partenopea/luca-fusilli':
    'Luca Fusilli',
  'player.south-europe/italian-league/squadra-partenopea/massimo-tarantini':
    'Massimo Tarantini',
  'player.south-europe/italian-league/squadra-partenopea/antonio-buccini':
    'Antonio Buccini',
  'player.south-europe/italian-league/squadra-partenopea/giuseppe-incotti':
    'Giuseppe Incotti',
  'player.south-europe/italian-league/squadra-partenopea/raffaele-fusco':
    'Raffaele Fusco',
  'player.south-europe/italian-league/squadra-partenopea/ciro-corradi':
    'Ciro Corradi',
  'player.south-europe/italian-league/murmillo-caeruleus/lucius-portarius':
    'Lucius Portarius',
  'player.south-europe/italian-league/murmillo-caeruleus/cassio-muralis':
    'Cassio Muralis',
  'player.south-europe/italian-league/murmillo-caeruleus/primo-scudiero':
    'Primo Scudiero',
  'player.south-europe/italian-league/murmillo-caeruleus/hector-ferrum':
    'Hector Ferrum',
  'player.south-europe/italian-league/murmillo-caeruleus/sergio-velox':
    'Sergio Velox',
  'player.south-europe/italian-league/murmillo-caeruleus/dante-virtus':
    'Dante Virtus',
  'player.south-europe/italian-league/murmillo-caeruleus/brujita': 'Brujita',
  'player.south-europe/italian-league/murmillo-caeruleus/pavel-luptator':
    'Pavel Luptator',
  'player.south-europe/italian-league/murmillo-caeruleus/antonius-bellator':
    'Antonius Bellator',
  'player.south-europe/italian-league/murmillo-caeruleus/valerius-velox':
    'Valerius Velox',
  'player.south-europe/italian-league/murmillo-caeruleus/marco-pugnator':
    'Marco Pugnator',
  'player.south-europe/italian-league/murmillo-caeruleus/sinisa-fulmen':
    'Sinisa Fulmen',
  'player.south-europe/italian-league/murmillo-caeruleus/ferdinandus-cauto':
    'Ferdinandus Cauto',
  'player.south-europe/italian-league/murmillo-caeruleus/matteo-almeda':
    'Matteo Almeda',
  'player.south-europe/italian-league/murmillo-caeruleus/attilius-ales':
    'Attilius Ales',
  'player.south-europe/italian-league/murmillo-caeruleus/robertus-mancinus-magister':
    'Robertus Mancinus Magister',
  'player.south-europe/italian-league/murmillo-caeruleus/simon-insigne':
    'Simon Insigne',
  'player.south-europe/italian-league/murmillo-caeruleus/paulus-niger':
    'Paulus Niger',
  'player.south-europe/italian-league/murmillo-caeruleus/fabrizio-alba':
    'Fabrizio Alba',
  'player.south-europe/italian-league/murmillo-caeruleus/ivan-parvus-calamus':
    'Ivan Parvus Calamus',
  'player.south-europe/italian-league/centuriones-rubri/gaius-aurelius-marcellus':
    'Gaius Aurelius Marcellus',
  'player.south-europe/italian-league/centuriones-rubri/flavius-augustus-cafu':
    'Flavius Augustus Cafu',
  'player.south-europe/italian-league/centuriones-rubri/lucius-julius-aldarius':
    'Lucius Julius Aldarius',
  'player.south-europe/italian-league/centuriones-rubri/marcus-valerius-samuellus':
    'Marcus Valerius Samuellus',
  'player.south-europe/italian-league/centuriones-rubri/vincentius-gallicus-candela':
    'Vincentius Gallicus Candela',
  'player.south-europe/italian-league/centuriones-rubri/ricardus-romanus-tommasius':
    'Ricardus Romanus Tommasius',
  'player.south-europe/italian-league/centuriones-rubri/eduardus-brasiliensis-emersonius':
    'Eduardus Brasiliensis Emersonius',
  'player.south-europe/italian-league/centuriones-rubri/hidekius-japonicus-nakata':
    'Hidekius Japonicus Nakata',
  'player.south-europe/italian-league/centuriones-rubri/lucas-augustus-assunção':
    'Lucas Augustus Assunção',
  'player.south-europe/italian-league/centuriones-rubri/gabrielus-batigol':
    'Gabrielus Batigol',
  'player.south-europe/italian-league/centuriones-rubri/georgius-bellator-totti':
    'Georgius Bellator Totti',
  'player.south-europe/italian-league/centuriones-rubri/gaius-julius-zottus':
    'Gaius Julius Zottus',
  'player.south-europe/italian-league/centuriones-rubri/marcus-delphinius-vetus':
    'Marcus Delphinius Vetus',
  'player.south-europe/italian-league/centuriones-rubri/christianus-zanettus-robustus':
    'Christianus Zanettus Robustus',
  'player.south-europe/italian-league/centuriones-rubri/eusebius-franciscus-celer':
    'Eusebius Franciscus Celer',
  'player.south-europe/italian-league/centuriones-rubri/jonathas-zebinius-gallus':
    'Jonathas Zebinius Gallus',
  'player.south-europe/italian-league/centuriones-rubri/amedeus-mango-fortis':
    'Amedeus Mango Fortis',
  'player.south-europe/italian-league/centuriones-rubri/christianus-lupus-custos':
    'Christianus Lupus Custos',
  'player.south-europe/italian-league/centuriones-rubri/johannes-gigas-urua':
    'Johannes Gigas Urua',
  'player.south-europe/italian-league/centuriones-rubri/abelus-balbus-argenti':
    'Abelus Balbus Argenti',
  'player.south-europe/italian-league/vecchia-signori/angelina-pellegruzzi':
    'Angelina Pellegruzzi',
  'player.south-europe/italian-league/vecchia-signori/serena-porretti':
    'Serena Porretti',
  'player.south-europe/italian-league/vecchia-signori/jolanda-carreri':
    'Jolanda Carreri',
  'player.south-europe/italian-league/vecchia-signori/carla-ferranti':
    'Carla Ferranti',
  'player.south-europe/italian-league/vecchia-signori/monica-torelli':
    'Monica Torelli',
  'player.south-europe/italian-league/vecchia-signori/antonia-contessa':
    'Antonia Contessa',
  'player.south-europe/italian-league/vecchia-signori/daniela-descharmes':
    'Daniela Descharmes',
  'player.south-europe/italian-league/vecchia-signori/bianca-baggioli':
    'Bianca Baggioli',
  'player.south-europe/italian-league/vecchia-signori/fabrizia-ravanelli':
    'Fabrizia Ravanelli',
  'player.south-europe/italian-league/vecchia-signori/giovanna-vialletti':
    'Giovanna Vialletti',
  'player.south-europe/italian-league/vecchia-signori/alessandra-del-piatti':
    'Alessandra Del Piatti',
  'player.south-europe/italian-league/vecchia-signori/lorenzo-squizzi':
    'Lorenzo Squizzi',
  'player.south-europe/italian-league/vecchia-signori/paola-sousa':
    'Paola Sousa',
  'player.south-europe/italian-league/vecchia-signori/angela-di-livia':
    'Angela Di Livia',
  'player.south-europe/italian-league/vecchia-signori/vladimira-jugo':
    'Vladimira Jugo',
  'player.south-europe/italian-league/vecchia-signori/giancarla-marrochi':
    'Giancarla Marrochi',
  'player.south-europe/italian-league/vecchia-signori/alessia-tacchini':
    'Alessia Tacchini',
  'player.south-europe/italian-league/vecchia-signori/roberta-jarni':
    'Roberta Jarni',
  'player.south-europe/italian-league/vecchia-signori/alessandra-orlando':
    'Alessandra Orlando',
  'player.south-europe/italian-league/vecchia-signori/luca-fusilli':
    'Luca Fusilli',
  'player.south-europe/italian-league/diavoli-immortali/luciano-ferraro':
    'Luciano Ferraro',
  'player.south-europe/italian-league/diavoli-immortali/matteo-taverna':
    'Matteo Taverna',
  'player.south-europe/italian-league/diavoli-immortali/lich-king-of-milan':
    'Lich King Of Milan',
  'player.south-europe/italian-league/diavoli-immortali/andrea-corsini':
    'Andrea Corsini',
  'player.south-europe/italian-league/diavoli-immortali/lich-prince-of-milan':
    'Lich Prince Of Milan',
  'player.south-europe/italian-league/diavoli-immortali/riccardo-donato':
    'Riccardo Donato',
  'player.south-europe/italian-league/diavoli-immortali/davide-albertini':
    'Davide Albertini',
  'player.south-europe/italian-league/diavoli-immortali/marc-antoine-dussault':
    'Marc-Antoine Dussault',
  'player.south-europe/italian-league/diavoli-immortali/danijel-stojanovic':
    'Danijel Stojanovic',
  'player.south-europe/italian-league/diavoli-immortali/jean-marc-pelletier':
    'Jean-Marc Pelletier',
  'player.south-europe/italian-league/diavoli-immortali/daniele-marchisio':
    'Daniele Marchisio',
  'player.south-europe/italian-league/diavoli-immortali/gabriele-lombardo':
    'Gabriele Lombardo',
  'player.south-europe/italian-league/diavoli-immortali/stephanus-eranius-diabolus':
    'Stephanus Eranius Diabolus',
  'player.south-europe/italian-league/diavoli-immortali/zvonimirus-bobanus-diabolus':
    'Zvonimirus Bobanus Diabolus',
  'player.south-europe/italian-league/diavoli-immortali/brianus-laudrupus-diabolus':
    'Brianus Laudrupus Diabolus',
  'player.south-europe/italian-league/diavoli-immortali/florinus-raducios-diabolus':
    'Florinus Raducios Diabolus',
  'player.south-europe/italian-league/diavoli-immortali/christianus-panuccius-diabolus':
    'Christianus Panuccius Diabolus',
  'player.south-europe/italian-league/diavoli-immortali/philippus-gallus-defensor':
    'Philippus Gallus Defensor',
  'player.south-europe/italian-league/diavoli-immortali/angelus-carbonius-labor':
    'Angelus Carbonius Labor',
  'player.south-europe/italian-league/diavoli-immortali/gianlucius-lenti-ala':
    'Gianlucius Lenti Ala',
};
